import React, { useEffect, useState } from "react";
import TableCompo from "../Table/TableCompo";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  CardContent,
  DialogContent,
  TextField,
  Button,
  useMediaQuery, useTheme
} from "@mui/material";
import { CiEdit } from "react-icons/ci";
import {
  fetchReferralOrdersRequest,
  verifyReferralOrderRequest,
} from "../../../redux/Order/RedeemOrdersSlice";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import useCsvConverter from "../../../hooks/convertToCSV";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


const UserPointsOrder = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const redeemOrders = useSelector((state) => state.redeemOrders || {});
  const {
    data: referralOrdersData = [],
    total = 0,
    error,
    lastAction,
  } = redeemOrders;

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [permissions, setPermissions] = useState({});

  const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("userPermissions");
    if (stored) {
      try {
        setPermissions(JSON.parse(stored));
      } catch (e) {
        console.error("permission parse error", e);
      }
    }
  }, []);
  const canEdit = canShowPermission(permissions, "userPointsOrder", "edit");

  const formatDateTimeRange = (date, type) => {
  if (!date) return null;
  const d = new Date(date);
  if (type === "start") {
    d.setHours(0, 0, 0, 0);
    return d.toISOString();
  }
  if (type === "end") {
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    return d.toISOString();
  }
};

  useEffect(() => {
    const payload = { start: 0, limit, search };
    if (startDate && endDate) {
      payload.startDate = formatDateTimeRange(startDate, "start");
      payload.endDate = formatDateTimeRange(endDate, "end");
    }
    dispatch(
      fetchReferralOrdersRequest(payload),
    );
  }, [dispatch, page, limit, search]);

  const handleGetDetails = () => {
  if (!startDate || !endDate) {
    toast.error("Please select both start and end dates.");
    return;
  }
  if (startDate > endDate) {
    toast.error("Start Date cannot be after End Date");
    return;
  }

  setPage(0);
  dispatch(
    fetchReferralOrdersRequest({
      start: 0,
      limit,
      search,
      startDate: formatDateTimeRange(startDate, "start"),
      endDate: formatDateTimeRange(endDate, "end"),
    })
  );
};

  useEffect(() => {
    if (error && lastAction === "fetchReferralOrders") {
      toast.error(error);
    }
  }, [error, lastAction]);

  useEffect(() => {
    if (error && lastAction === "fetchReferralOrders") {
      toast.error(error);
    }
  }, [error, lastAction]);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleApprove = () => {
    if (!selectedRow || !inputValue) {
      toast.error("Please enter OTP");
      return;
    }

    dispatch(
      verifyReferralOrderRequest({
        orderId: selectedRow._id,
        otp: inputValue,
      }),
    );

    setOpen(false);
    setInputValue("");
  };

  const handleTableChange = (action, tableState) => {
    const dateParams =
    startDate && endDate
      ? {
          startDate: formatDateTimeRange(startDate, "start"),
          endDate: formatDateTimeRange(endDate, "end"),
        }
      : {};
    switch (action) {
      case "changePage":
        setPage(tableState.page);
        dispatch(
          fetchReferralOrdersRequest({
            start: tableState.page * tableState.rowsPerPage,
            limit: tableState.rowsPerPage,
            search,
            ...dateParams,
          }),
        );
        break;

      case "changeRowsPerPage":
        setLimit(tableState.rowsPerPage);
        setPage(0);
        dispatch(
          fetchReferralOrdersRequest({
            start: 0,
            limit: tableState.rowsPerPage,
            search,
            ...dateParams,
          }),
        );
        break;

      case "search":
        const searched = tableState.searchText || "";
        setSearch(searched);
        setPage(0);
        dispatch(
          fetchReferralOrdersRequest({ start: 0, limit, search: searched,...dateParams,}),
        );
        break;

      default:
        break;
    }
  };

  const columns = [
    {
      field: "_id-edit",
      headerName: "Edit",
      minWidth: 100,
      render: (value, row) => {
        if (!canEdit) return null;
        if (row.status !== "PENDING") return null;

        return (
          <CiEdit
            style={{ cursor: "pointer", fontSize: "24px" }}
            onClick={() => handleEditClick(row)}
          />
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      render: (val, row) => {
        return row?.createdAt
          ? new Date(row.createdAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "N.A";
      },
    },
    {
      field: "user",
      headerName: "User Name",
      render: (val, row) => (row.user ? `${row.user.name || ""}` : "N.A"),
    },
    {
      field: "phone",
      headerName: "Phone",
      render: (val, row) => (row.user ? `${row.user.phone || ""}` : "N.A"),
    },
    {
      field: "amount",
      headerName: "Amount",
    },
    {
      field: "pointsRedeemed",
      headerName: "Points Redeemed",
    },
    {
      field: "Store",
      headerName: "Branch Name",
      render: (val, row) =>
        row.store ? `${row.store.branchName || ""}` : "N.A",
    },
    {
      field: "status",
      headerName: "Status",
      render: (val, row) => {
        let color;
        switch (row.status) {
          case "SUCCESS":
            color = "green";
            break;
          case "PENDING":
            color = "blue";
            break;
          default:
            color = "red";
            break;
        }

        return <span style={{ color, fontWeight: "bold" }}>{row.status}</span>;
      },
    },
  ];

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadCsv = () => {
    const query = {};
    if (startDate && endDate) {
      query.startDate = formatDateTimeRange(startDate, "start");
      query.endDate = formatDateTimeRange(endDate, "end");
    }
    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/referral/referralPointsCsv",
        query,
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "referralPoints.csv");
        },
      }),
    );
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} p={2} fontFamily={"Aeonik"}>
          Referral Orders List
        </Typography>

        <CardContent sx={{ height: "580px", width: "100%" }}>
          <Box display="flex" gap={1.5} px={2} pb={1} flexWrap="wrap" alignItems="center">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Box
                          display="flex"
                          flexDirection={isMobile ? "column" : "row"}
                          gap={1.5}
                          px={2}
                          py={1}
                        >
                          <DatePicker
                            label="Start Date"
                            value={startDate}
                            onChange={setStartDate}
                            maxDate={endDate || new Date()}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: {
                                  minWidth: 160,
                                  "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                                  "& .MuiInputLabel-root": { fontSize: 13 },
                                },
                              },
                            }}
                          />
                            
                          <DatePicker
                            label="End Date"
                            value={endDate}
                            onChange={setEndDate}
                            minDate={startDate}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: {
                                  minWidth: 160,
                                  "& .MuiInputBase-root": { height: 36, fontSize: 13 },
                                  "& .MuiInputLabel-root": { fontSize: 13 },
                                },
                              },
                            }}
                          />
                          <Button
                            variant="outlined"
                            fullWidth={isMobile}
                            sx={{
                              height: 36,
                              minWidth: 120,
                              fontSize: 13,
                              textTransform: "none",
                              px: 2,
                              whiteSpace: "nowrap",
                            }}
                              onClick={handleGetDetails}
                          >
                            Get Details
                          </Button>
                        </Box>
                      </LocalizationProvider>
                </Box>
          
          <TableCompo
            columns={columns}
            data={[...JSON.parse(JSON.stringify(referralOrdersData))]}
            totalCount={total}
            page={page}
            limit={limit}
            onTableChange={handleTableChange}
            extraButtons={
              <Button size="sm" variant="outlined" onClick={handleDownloadCsv}>
                Download CSV
              </Button>
            }
          />
        </CardContent>
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Redeem Order Verification
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              color: (theme) => theme.palette.grey[500],
              padding: 0,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <p>Please Enter OTP</p>
          <TextField
            fullWidth
            margin="normal"
            label="Enter OTP"
            value={inputValue}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d{0,4}$/.test(value)) {
                setInputValue(value);
              }
            }}
            inputProps={{ maxLength: 4 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleApprove}
            sx={{ mt: 2 }}
          >
            Approve
          </Button>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default UserPointsOrder;
